import React from 'react';
import { MediumHeadline } from '@minted/fancyclothes';
import { css } from '@emotion/react';
import { styleUtils, theme } from '@minted/minted-components';
import { selectors } from '../../add-element/cypressSelectors';
import { DisplayDividerSection } from '../../add-element/website-display/section-types/DisplayDividerSection';

type DisplayTitleProps = {
    title: string,
    hideDivider: boolean,
};

const alignmentStyles = (hideDivider: boolean) => css`
  display: grid;
  justify-content: center;
  row-gap: ${theme.spacing.x8};
  text-align: center;
  margin-top: ${styleUtils.rem(80)};

  ${hideDivider && css`margin-bottom: ${theme.spacing.x8};`}
`;

const dividerStyles = css`
  margin-bottom: ${theme.spacing.x4};
`;

const DisplayTitle = ({
  hideDivider, title,
}: DisplayTitleProps) => (
  <div
    css={alignmentStyles(hideDivider)}
    data-cy={selectors.website_displayPageTitle}
  >
    <MediumHeadline>
      {title}
    </MediumHeadline>
    {
      !hideDivider && (
        <div css={dividerStyles}>
          <DisplayDividerSection />
        </div>
      )
    }
  </div>
);

export default DisplayTitle;
